import React from 'react';
import style from 'acscp/components/common/sideScreen.module.scss';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { AppState, Menu } from 'acscp/store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { SideScreen } from 'acscp/components/common/sideScreen';
import { SetOpenMenu } from 'acscp/actions';
import { FormattedMessage } from 'react-intl';
import { LogoutButton } from 'acscp/components/auth/logoutButton';
import { LoginButton } from 'acscp/components/auth/loginButton';
import { ACS_WEBSITE } from 'acscp/settings/appSettings';
import { Link } from 'react-router-dom';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import {
    userCanAccessCharters,
    userCanAccessLoyalty,
    userCanPotentiallyRequestFlights,
    userIsLoggedIn
} from 'acscp/store/helpers/authHelper';
import { LanguageMenuButton } from '../intl/languageMenuButton';
import { newFlightRequest } from '../routeHelper';

interface HamburgerMenuStateProps {
    isOpen: boolean;
    isLoggedIn: boolean;
    isNonJetPortalUser: boolean;
    canAccessCharters: boolean;
    canAccessLoyalty: boolean;
    canPotentiallyRequestFlights: boolean;
    mainSiteLink?: string;
}

interface HamburgerMenuDispatchProps {
    openCustomerDetailsMenu: () => void;
    closeMenu: () => void;
    openLanguageMenu: () => void;
}

export class HamburgerMenuPresentational extends PresentationComponentBase<{},
    HamburgerMenuStateProps, HamburgerMenuDispatchProps, {}> {

    render(): JSX.Element | null {
        return this.props.isOpen
            ? (
                <SideScreen>
                    <div className={style.BlueHeader} >
                        <FormattedMessage
                            id={'components.hamburgerMenu.menu'}
                            defaultMessage={'MENU'}
                        />
                        <a href="javascript:;" id="Exit" onClick={this.props.closeMenu} aria-label="Close menu">
                            <CrossIcon />
                        </a>
                    </div>
                    {this.props.canPotentiallyRequestFlights &&
                        <Link to={newFlightRequest()} onClick={this.props.closeMenu} className={style.ItemWithLink}>
                            <FormattedMessage
                                id={'components.hamburgerMenu.newEnquiry'}
                                defaultMessage={'New Enquiry'}
                            />
                        </Link>
                    }
                    {this.props.canAccessCharters &&
                        <Link to="/trip" onClick={this.props.closeMenu} className={style.ItemWithLink}>
                            <FormattedMessage
                                id={'components.hamburgerMenu.myCharters'}
                                defaultMessage={'My Charters'}
                            />
                        </Link>
                    }
                    {this.props.canAccessLoyalty &&
                        <Link to="/loyalty" onClick={this.props.closeMenu} className={style.ItemWithLink}>
                            <FormattedMessage
                                id={'components.hamburgerMenu.myRewards'}
                                defaultMessage={'My Rewards'}
                            />
                        </Link>
                    }
                    {this.props.isLoggedIn &&
                        <div
                            className={style.ItemWithLink}
                            onClick={this.props.openCustomerDetailsMenu}
                        >
                            <FormattedMessage
                                id={'components.hamburgerMenu.myAccount'}
                                defaultMessage={'My Account'}
                            />
                        </div>
                    }
                    {ALLOW_LANGUAGE_SELECTION &&
                        <div
                            className={style.ItemWithLink}
                            onClick={this.props.openLanguageMenu}
                        >
                            <LanguageMenuButton/>
                        </div>
                    }
                    <a
                        href={this.props.mainSiteLink || ACS_WEBSITE}
                        className={style.ItemWithLink}
                        target={'_blank'}
                    >
                        <FormattedMessage
                            id={'components.hamburgerMenu.acsMainSite'}
                            defaultMessage={'ACS Main Site'}
                        />
                    </a>
                    {this.props.isLoggedIn &&
                        <div className={style.ItemWithLink} onClick={this.props.closeMenu}>
                            <LogoutButton />
                        </div>
                    }
                    {!this.props.isLoggedIn && !this.props.isNonJetPortalUser &&
                        <div className={style.ItemWithLink} onClick={this.props.closeMenu}>
                            <LoginButton />
                        </div>
                    }
                </SideScreen>
            )
            : (
                null
            );
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): HamburgerMenuDispatchProps {
    return {
        openCustomerDetailsMenu: () => dispatch(new SetOpenMenu(Menu.CustomerContactDetails)),
        closeMenu: () => dispatch(new SetOpenMenu(undefined)),
        openLanguageMenu: () => dispatch(new SetOpenMenu(Menu.Language))
    };
}

function mapStateToProps(state: AppState, ownProps: {}): HamburgerMenuStateProps {
    return {
        isOpen: state.menu.currentlyOpenMenu === Menu.Hamburger,
        isLoggedIn: userIsLoggedIn(state.auth),
        isNonJetPortalUser: state.auth.isNonJetPortalUser,
        canAccessCharters: userCanAccessCharters(state.auth),
        canAccessLoyalty: userCanAccessLoyalty(state.auth),
        canPotentiallyRequestFlights: userCanPotentiallyRequestFlights(state.auth),
        mainSiteLink: state.customerContact.mainSiteLink,
    };
}

export const HamburgerMenu = connect(mapStateToProps, mapDispatchToProps)(HamburgerMenuPresentational);
